// A styled native <select>: accessible and phone-friendly (shadcn/ui "native-select").
import { ChevronDown } from 'lucide-react';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export function NativeSelect({ className, children, ...props }: ComponentProps<'select'>) {
  return (
    <div className={cn('relative', className)}>
      <select
        className="h-9 w-full appearance-none rounded-md border border-border-strong bg-bg py-0 pr-8 pl-3 text-sm text-text disabled:opacity-50"
        {...props}
      >
        {children}
      </select>
      <ChevronDown aria-hidden="true" className="pointer-events-none absolute top-2.5 right-2.5 size-4 text-muted" />
    </div>
  );
}
